import React from 'react';
import { Check as IconCheck } from "flowbite-react-icons/outline";

interface Props {
    checked: boolean;
}

const CheckBox: React.FC<Props> = (props: Props) => {

    return (
        <div className={"z-checkbox cursor-pointer" + (props.checked ? " checked" : "")}>
          {props.checked && <IconCheck className="size-5 text-neutral-900!" aria-hidden="true" />}
        </div>
    );
};

export default CheckBox;
